import moment from 'moment';

export const getSumOfOverallPercentage = overall => {
  return overall
    .map(overallInfo => overallInfo.value)
    .reduce(
      (overallSum, actualOverallValue) => overallSum + actualOverallValue
    );
};

export const getPeriodRange = periodInput => {
  const periodValues = {
    startPeriod: periodInput.startDate.format('YYYY-MM-DD')
  };

  if (!periodInput.endDate) {
    periodValues.endPeriod = moment().format('YYYY-MM-DD');
  } else {
    periodValues.endPeriod = periodInput.endDate.format('YYYY-MM-DD');
  }

  return periodValues;
};

export const prepareReceivedStatisticsData = data => {
  if (!data) return [];

  const preparedData = {
    accommodationStatistics: {},
    openActivitiesStatistics: {},
    privateActivitiesStatistics: {}
  };

  const accommodationStatistics = data.accommodationsBookingsStatistic;
  const openActivitiesStatistics = data.activitiesBookingsStatistic.open;
  const privateActivitiesStatistics = data.activitiesBookingsStatistic.private;

  if (accommodationStatistics) {
    preparedData.accommodationStatistics.total =
      accommodationStatistics.numberOfBookedSlots;

    preparedData.accommodationStatistics.platformsLegendData = preparePlatformsLegend(
      accommodationStatistics.bookingsPerPlatform
    );

    preparedData.accommodationStatistics.overallLegendData = prepareOverallLegendForAccommodation(
      accommodationStatistics
    );

    preparedData.accommodationStatistics.bookingsInfo = prepareBookingsPerAccommodationData(
      accommodationStatistics.accommodationBookings
    );
  }

  if (openActivitiesStatistics) {
    preparedData.openActivitiesStatistics.total =
      openActivitiesStatistics.bookedParticipants;

    preparedData.openActivitiesStatistics.platformsLegendData = preparePlatformsLegend(
      openActivitiesStatistics.bookingsPerPlatform
    );

    preparedData.openActivitiesStatistics.overallLegendData = prepareOverallLegendForOpenActivity(
      openActivitiesStatistics
    );

    preparedData.openActivitiesStatistics.bookingsInfo = prepareBookingsPerOpenActivityData(
      openActivitiesStatistics.bookingPerActivity
    );
  }

  if (privateActivitiesStatistics) {
    preparedData.privateActivitiesStatistics.total =
      privateActivitiesStatistics.bookedSlots;

    preparedData.privateActivitiesStatistics.platformsLegendData = preparePlatformsLegend(
      privateActivitiesStatistics.bookingsPerPlatform
    );

    preparedData.privateActivitiesStatistics.overallLegendData = prepareOverallLegendForPrivateActivity(
      privateActivitiesStatistics
    );

    preparedData.privateActivitiesStatistics.bookingsInfo = prepareBookingsPerPrivateActivityData(
      privateActivitiesStatistics.bookingPerActivity
    );
  }
  return preparedData;
};

const preparePlatformsLegend = bookingsPerPlatform => {
  const legendData = [];
  if (!bookingsPerPlatform) {
    return [];
  }
  bookingsPerPlatform.forEach(item => {
    legendData.push({
      name: item.platform,
      value: item.bookingsPerPlatform,
      legendTitle: item.platform
    });
  });
  return legendData;
};

const prepareOverallLegendForAccommodation = data => {
  return [
    {
      name: 'capacityBooked',
      value: data.capacityBooked,
      legendTitle: 'Booked slots'
    },
    {
      name: 'capacityAvailable',
      value: data.capacityAvailable,
      legendTitle: 'Available slots'
    }
  ];
};

const prepareOverallLegendForOpenActivity = data => {
  return [
    {
      name: 'capacityBooked',
      value: data.capacityBooked,
      legendTitle: 'Booked seats'
    },
    {
      name: 'capacityAvailable',
      value: data.capacityAvailable,
      legendTitle: 'Available seats'
    }
  ];
};

const prepareOverallLegendForPrivateActivity = data => {
  return [
    {
      name: 'capacityBooked',
      value: data.capacityBooked,
      legendTitle: 'Booked slots'
    },
    {
      name: 'capacityAvailable',
      value: data.capacityAvailable,
      legendTitle: 'Available slots'
    }
  ];
};

const prepareBookingsPerAccommodationData = bookingsInfo => {
  const preparedData = [];
  bookingsInfo.forEach(item => {
    preparedData.push({
      total: item.numberOfBookedSlots,
      status: item.status,
      title: item.accommodationTitle
    });
  });
  return preparedData;
};

const prepareBookingsPerOpenActivityData = bookingsInfo => {
  const preparedData = [];
  bookingsInfo.forEach(item => {
    preparedData.push({
      total: item.bookedParticipants ? parseInt(item.bookedParticipants) : 0,
      status: item.status,
      title: item.activityTitle
    });
  });
  return preparedData;
};

const prepareBookingsPerPrivateActivityData = bookingsInfo => {
  const preparedData = [];
  bookingsInfo.forEach(item => {
    preparedData.push({
      total: item.numberOfBookedSlots ? parseInt(item.numberOfBookedSlots) : 0,
      status: item.status,
      title: item.activityTitle
    });
  });
  return preparedData;
};
